import {RequestAwbComponent} from "./request-awb.component";

export default RequestAwbComponent
